const createProgram = ({
  name,
  type,
  sourceUrl,
  overview,
  credential,
  format,
  length,
  tuition,
  admissions,
  focus,
  highlights,
  address,
}) => ({
  name,
  type,
  credential,
  format,
  length,
  tuition,
  admissions,
  summary: overview,
  badge: type,
  websiteUrl: sourceUrl,
  sourceUrl,
  specs: [
    ['Program type', type],
    ['Credential', credential],
    ['Class format', format],
    ['Program length', length],
    ['Tuition and fees', tuition],
    ['Admissions', admissions],
  ],
  paragraphs: [
    focus,
    'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
  ],
  highlights,
  address,
  mapEmbedUrl: `https://www.google.com/maps?q=${encodeURIComponent(
    address,
  )}&output=embed`,
});

export const programs = [
  createProgram({
    name: 'The Refrigeration School, Inc. (RSI)',
    type: 'Private HVAC/R technical school',
    sourceUrl:
      'https://www.rsi.edu/?vid=stratatech&utm_source=google+plus&utm_medium=organic&utm_campaign=gmb-rsi',
    overview:
      'RSI’s Refrigeration Technologies program offers intensive, in-person training designed to prepare students for entry-level careers in HVAC and refrigeration. Students receive career-focused technical instruction with hands-on practice using tools and real systems alongside certification preparation.',
    credential:
      'Refrigeration Technologies program credential; verify the current program award with RSI',
    format:
      'Intensive, in-person classroom instruction with hands-on HVAC/R laboratory training',
    length:
      'Full-length HVAC/R training program; verify the current completion timeline with RSI',
    tuition: '$7,000 to $15,000',
    admissions: 'Review current RSI admissions requirements and start dates',
    focus:
      'RSI is a strong option for students seeking robust, career-focused technical training in Phoenix. Ask about the current Refrigeration Technologies curriculum, lab hours, real-system practice, EPA Section 608 preparation, certification testing, attendance schedule, and career services.',
    highlights: [
      'Intensive in-person HVAC and refrigeration training',
      'Hands-on practice with tools and real systems',
      'Career-focused preparation for entry-level HVAC/R work',
      'Certification preparation integrated into technical training',
    ],
    address: 'The Refrigeration School, Inc., Phoenix, AZ',
  }),
  createProgram({
    name: 'GateWay Community College - Washington Campus',
    type: 'Public community college HVAC program',
    sourceUrl: 'https://www.gatewaycc.edu/degrees-certificates/hvac',
    overview:
      'GateWay Community College offers structured HVAC pathways through its Residential HVAC Certificate of Competency and Associate in Applied Science degree options. Students receive affordable public-college instruction covering climate-control theory and practical maintenance work.',
    credential:
      'Residential HVAC Certificate of Competency or Associate in Applied Science degree; verify current requirements',
    format:
      'Community college coursework with classroom instruction, laboratory work, and practical maintenance training',
    length:
      'Certificate and degree timelines vary by course sequence and enrollment pace',
    tuition: '$5,400',
    admissions:
      'Review GateWay and Maricopa Community Colleges admissions requirements',
    focus:
      'GateWay is an affordable option for students who want a structured public-education pathway. Compare the Residential HVAC Certificate of Competency with the AAS degree, then ask about course requirements, lab access, equipment, financial aid, class schedules, and practical maintenance training.',
    highlights: [
      'Residential HVAC Certificate of Competency pathway',
      'Associate in Applied Science degree option',
      'Approximately $5,400 in-county certificate estimate',
      'Instruction covering climate-control theory and maintenance work',
    ],
    address: 'GateWay Community College - Washington Campus, Phoenix, AZ',
  }),
  createProgram({
    name: 'Universal Technical Institute - Avondale/Phoenix Area',
    type: 'Private technical career school',
    sourceUrl: 'https://www.uti.edu/programs/hvacr',
    overview:
      'UTI’s HVACR technician training program prepares students to work with commercial and residential heating, ventilation, air conditioning, and refrigeration systems. The program balances classroom learning with hands-on laboratory training and was designed with input from industry leaders.',
    credential:
      'HVACR technician training credential with preparation for EPA Section 608 and NATE Core testing',
    format:
      'Classroom instruction combined with hands-on laboratory training on residential and commercial systems',
    length: 'Approximately 9 to 10 months',
    tuition: 'Varies by location and schedule',
    admissions:
      'Review current UTI admissions requirements and Phoenix-area campus options',
    focus:
      'UTI students can prepare for important market certifications such as EPA Section 608 and NATE Core testing. Ask about the current lab schedule, equipment, commercial and residential system practice, financial aid, employer network assistance, and graduate career services.',
    highlights: [
      'Approximately 9 to 10 months of HVACR technician training',
      'Preparation for EPA Section 608 and NATE Core testing',
      'Hands-on work with commercial and residential systems',
      'Financial-aid options and employer network assistance',
    ],
    address: 'Universal Technical Institute, Avondale/Phoenix Area, AZ',
  }),
  createProgram({
    name: 'UEI College - Phoenix Campus',
    type: 'Private career training school',
    sourceUrl:
      'https://www.uei.edu/trade-school/arizona/phoenix/heating-ventilation-and-air-conditioning-hvac-in-phoenix/',
    overview:
      'UEI College provides an accelerated hybrid HVAC training program for Phoenix students seeking flexible career preparation. The curriculum combines online learning modules with hands-on laboratory work covering electrical theory, automatic controls, and air-conditioning troubleshooting.',
    credential:
      'HVAC technician training diploma or credential; verify the current award and certification options',
    format:
      'Accelerated hybrid program combining online instruction with hands-on laboratory training',
    length: 'Approximately 10 months',
    tuition: 'Contact UEI for current tuition and fees',
    admissions: 'Review current UEI Phoenix admissions requirements',
    focus:
      'UEI’s hybrid format is designed for students who want flexible scheduling while developing practical HVAC skills. Ask about the current electrical theory, automatic controls, AC troubleshooting, lab hours, certification preparation, graduation requirements, and career services.',
    highlights: [
      'Accelerated hybrid HVAC training format',
      'Approximately 10-month completion timeline',
      'Online modules combined with hands-on labs',
      'Training in electrical theory, automatic controls, and AC troubleshooting',
    ],
    address: 'UEI College - Phoenix Campus, Phoenix, AZ',
  }),
  createProgram({
    name: 'San Joaquin Valley College - Phoenix Campus',
    type: 'Private career college HVAC/R program',
    sourceUrl: 'https://www.sjvc.edu/location/phoenix-tec/',
    overview:
      'SJVC offers a Heating, Ventilation, Air Conditioning, and Refrigeration program at its Phoenix campus. Students train in air distribution, electrical theory, and refrigeration systems while working toward a Certificate of Completion or an Associate of Science degree.',
    credential:
      'HVAC-R Certificate of Completion or Associate of Science degree',
    format:
      'Career college instruction with classroom lessons and extensive hands-on technical training',
    length:
      'Certificate of Completion in as few as 10 months or Associate of Science degree in approximately 14 months',
    tuition: 'Contact SJVC for current tuition and fees',
    admissions:
      'Confirm current Phoenix HVAC-R admissions requirements and enrollment dates',
    focus:
      'SJVC provides multiple credential options for students who want either a shorter certificate pathway or a longer associate degree. Students may have opportunities to earn OSHA 10-Hour Construction and EPA Section 608 certifications before graduation. Confirm current certification requirements and testing arrangements with SJVC.',
    highlights: [
      'HVAC-R Certificate of Completion in as few as 10 months',
      'Associate of Science degree option in approximately 14 months',
      'Training in air distribution, electrical theory, and refrigeration',
      'Potential OSHA 10-Hour Construction and EPA 608 certifications',
    ],
    address: 'San Joaquin Valley College - Phoenix Campus, Phoenix, AZ',
  }),
  createProgram({
    name: 'Vocational Training Institute (VTI)',
    type: 'Private vocational training school',
    sourceUrl: 'https://myvocationaltrainingaz.com/',
    overview:
      'Vocational Training Institute delivers focused, hands-on trade instruction designed to build practical competencies for local HVAC technicians. The school emphasizes direct shop-floor training, safety standards, and tool proficiency for students preparing to work with residential and light commercial equipment.',
    credential: 'Vocational HVAC credential; verify the current diploma or certificate',
    format: 'Hands-on vocational instruction with direct shop-floor practice',
    length: 'Verify the current HVAC program duration with VTI',
    tuition: 'Contact VTI for current tuition and fees',
    admissions: 'Review current VTI admissions requirements and enrollment dates',
    focus:
      'VTI is focused on practical readiness for local HVAC work. Ask about the current equipment, shop-floor hours, safety curriculum, tool training, residential and light commercial system practice, troubleshooting exercises, and employer or placement support.',
    highlights: [
      'Focused hands-on vocational instruction',
      'Direct shop-floor training for practical competencies',
      'Emphasis on safety standards and tool proficiency',
      'Preparation for residential and light commercial equipment',
    ],
    address: 'Vocational Training Institute, Phoenix, AZ',
  }),
  createProgram({
    name: 'National Technical Institute - Phoenix Campus',
    type: 'Private technical training school',
    sourceUrl: 'https://www.ntitraining.com/locations/phoenix/',
    overview:
      'NTI’s traditional HVAC/I training program provides an intensive in-person route into HVAC service work. The program is designed around direct preparation for essential credentials and uses a short, concentrated schedule for students who want to begin technical training quickly.',
    credential:
      'HVAC/I training credential with preparation for the EPA 608 Universal license',
    format:
      'Traditional daytime or evening in-person classroom and hands-on training',
    length: 'Approximately 12 weeks and 192 total hours',
    tuition: '$10,995',
    admissions:
      'Review current NTI Phoenix admissions requirements and daytime or evening schedules',
    focus:
      'NTI’s intensive program is designed for students who want concentrated HVAC/I instruction. Ask about the current 192-hour schedule, hands-on equipment practice, EPA 608 Universal testing, class size, daytime and evening availability, attendance requirements, and career support.',
    highlights: [
      'Approximately 12-week HVAC/I training program',
      'Roughly 192 total hours of instruction',
      'Estimated $10,995 including books and required supplies',
      'Preparation for the EPA 608 Universal license',
      'Daytime and evening in-person class options',
    ],
    address: 'National Technical Institute - Phoenix Campus, Phoenix, AZ',
  }),
  createProgram({
    name: 'West-MEC - Western Maricopa Education Center',
    type: 'Public career and technical education program',
    sourceUrl:
      'https://www.west-mec.edu/adult-students/career-training-programs/hvac-r-certification-program-in-arizona',
    overview:
      'West-MEC offers specialized adult career training focused on HVAC-R certification and the needs of the regional skilled-trades workforce. Students receive hands-on technical education using modern industry equipment while learning installation, diagnostics, and component repair.',
    credential:
      'HVAC-R certification program; verify the current certificate and requirements',
    format:
      'Adult career and technical education with classroom instruction and hands-on laboratory training',
    length: 'Verify the current HVAC-R program hours and schedule',
    tuition: 'Contact West-MEC for current tuition and fees',
    admissions: 'Review current West-MEC adult-student admissions requirements',
    focus:
      'West-MEC is designed for adult students seeking practical preparation for Arizona’s skilled trades. Ask about the current installation, diagnostics, component repair, equipment, lab hours, certification requirements, class schedule, and career resources.',
    highlights: [
      'Specialized adult HVAC-R certification training',
      'Hands-on instruction using modern industry equipment',
      'Training in installation, diagnostics, and component repair',
      'Designed around regional Arizona workforce demands',
    ],
    address:
      'West-MEC - Western Maricopa Education Center, Phoenix Area, AZ',
  }),
];

export const resources = [
  {
    title: 'Arizona Registrar of Contractors',
    description:
      'Review Arizona contractor licensing information and current HVAC-related requirements.',
    url: 'https://roc.az.gov/',
  },
  {
    title: 'EPA Section 608 Technician Certification',
    description:
      'Review federal refrigerant handling requirements and approved certification programs.',
    url: 'https://www.epa.gov/section608',
  },
  {
    title: 'Air-Conditioning, Heating, and Refrigeration Institute',
    description:
      'Explore industry standards, equipment efficiency information, and HVAC career resources.',
    url: 'https://www.ahrinet.org/',
  },
  {
    title: 'U.S. Bureau of Labor Statistics',
    description:
      'Research HVAC mechanic and installer duties, pay, education, and employment outlook.',
    url: 'https://www.bls.gov/ooh/installation-maintenance-and-repair/heating-air-conditioning-and-refrigeration-mechanics-and-installers.htm',
  },
];